import { Component, h, Host, Prop } from '@stencil/core'
import { CompanyAvatar } from 'src/utils/avatar'

import { CallCompanyLink } from '../company/ui'
import { ICallChip } from '../types'
@Component({
  tag: 'call-avatar',
})
export class CallAvatar {
  @Prop() call: ICallChip

  render() {
    const thumbnail = <CompanyAvatar style={{ fontSize: '2.5em' }} company={this.call.company} />
    return (
      thumbnail && (
        <Host
          style={{ width: '1em', height: '1em', borderRadius: '.1em' }}
          class='flex overflow-hidden relative flex-shrink-0'
          hidden={this.call.internal}
        >
          <CallCompanyLink call={this.call}>{thumbnail}</CallCompanyLink>
        </Host>
      )
    )
  }
}
